import React, { createRef, useState } from 'react';
import { Button, Carousel, Col, Divider, Modal, Row, Typography } from 'antd';
const { Paragraph } = Typography;
const FeatureTourModal = ({ onClose, isOpen, descriptions, modalWidth }) => {
    const onChange = (currentSlide) => {
        setCurrentSlide(currentSlide);
    };
    function onCloseHandler() {
        onClose();
        setCurrentSlide(0);
        carousel?.current?.goTo(0);
    }
    const [currentSlide, setCurrentSlide] = useState(0);
    const carousel = createRef();
    return (React.createElement(Modal, { open: isOpen, footer: [
            React.createElement("div", { className: "d-flex justify-content-between py-3", key: 1 },
                React.createElement("div", null,
                    React.createElement(Button, { type: "ghost", onClick: onCloseHandler }, "Dismiss")),
                React.createElement("div", { className: "d-flex", style: { columnGap: '6px' } },
                    currentSlide !== 0 && (React.createElement(Button, { type: "ghost", onClick: () => carousel?.current?.prev() }, "Previous")),
                    React.createElement(Button, { type: "primary", onClick: () => {
                            if (currentSlide === descriptions.length - 1) {
                                onCloseHandler();
                            }
                            else {
                                carousel?.current?.next();
                            }
                        } }, currentSlide === descriptions.length - 1 ? "Let's Go!" : 'Next'))),
        ], width: modalWidth, style: { marginTop: '0!important', minWidth: '360px' }, bodyStyle: { padding: 0 }, onCancel: onCloseHandler, closable: false, destroyOnClose: true, centered: true },
        React.createElement(Row, { className: "m-0" },
            React.createElement(Col, { md: 24, span: 24 },
                React.createElement("div", { className: "d-flex flex-column h-100 px-5 pt-4" },
                    React.createElement("span", { className: "font-size-xxl font-weight-bold" }, "Feature Tour"),
                    React.createElement(Divider, { style: { marginBottom: 0 } }))),
            React.createElement(Col, { md: 8 },
                React.createElement("div", { className: "d-md-flex flex-column h-100 align-items-md-center d-none p-md-4 p-3" },
                    React.createElement("div", { className: "d-flex flex-column" },
                        React.createElement("span", { className: "font-size-lg font-weight-med mb-3" }, descriptions.find(x => x.key === currentSlide)?.title),
                        React.createElement(Paragraph, { className: "font-size-base mb-0" }, descriptions.find(x => x.key === currentSlide)?.description)))),
            React.createElement(Col, { md: 16, className: "p-md-4 p-1" },
                React.createElement(Carousel, { afterChange: onChange, ref: carousel }, descriptions.map(slide => (React.createElement("img", { key: slide.key, src: slide.img, alt: slide.alt, loading: "lazy" })))))),
        React.createElement("div", { className: "d-md-none d-flex flex-column h-100 align-items-md-center p-md-0 p-3" },
            React.createElement("div", { className: "d-flex flex-column" },
                React.createElement("span", { className: "font-size-lg font-weight-med mb-3" }, descriptions.find(x => x.key === currentSlide)?.title),
                React.createElement(Paragraph, { className: "font-size-base mb-0" }, descriptions.find(x => x.key === currentSlide)?.description)))));
};
export default FeatureTourModal;
